import { RawPointerEvent, UIEventListeners } from '../../../../common/src/ts/types/uievent';

// NOTE : contentWindowが違うことがあるので、typeofが使えないケースに対応

export const isMouseEvent = (ev: RawPointerEvent): ev is MouseEvent => {
  return !isTouchEvent(ev) && !isPointerEvent(ev) && ('button' in ev);
};

export const isTouchEvent = (ev: RawPointerEvent): ev is TouchEvent => {
  return ('changedTouches' in ev);
};

export const isPointerEvent = (ev: RawPointerEvent): ev is PointerEvent => {
  return ('isPrimary' in ev);
};

export const hasPointerEvents = () => window.onpointerdown !== undefined;

export const registerUIEventListeners = (
  target1: HTMLElement | Document,
  listeners: UIEventListeners,
) => {
  // Hack: TypeScript型定義ファイルの不具合か、"HTMLElement | Document" だとエラーになるのでごまかす
  const target = target1 as Document;

  if (hasPointerEvents()) {
    target.addEventListener('pointerdown', listeners.onPointerDown);
    target.addEventListener('pointerup', listeners.onPointerUp);
    target.addEventListener('pointermove', listeners.onPointerMove);
    target.addEventListener('pointercancel', listeners.onPointerUp);
  } else {
    // Safari
    // TODO : Support desktop Safari.
    target.addEventListener('touchstart', listeners.onPointerDown);
    target.addEventListener('touchend', listeners.onPointerUp);
    target.addEventListener('touchmove', listeners.onPointerMove);
    target.addEventListener('touchcancel', listeners.onPointerUp);

    target.addEventListener('gesturestart', listeners.onGestureStart);
    target.addEventListener('gesturechange', listeners.onGestureChange);
    target.addEventListener('gestureend', listeners.onGestureEnd);
  }
};

export const unregisterUIEventListeners = (
  target1: HTMLElement | Document,
  listeners: UIEventListeners,
) => {
  // Hack: See registerUIEventListeners
  const target = target1 as Document;

  if (hasPointerEvents()) {
    target.removeEventListener('pointerdown', listeners.onPointerDown);
    target.removeEventListener('pointerup', listeners.onPointerUp);
    target.removeEventListener('pointermove', listeners.onPointerMove);
    target.removeEventListener('pointercancel', listeners.onPointerUp);
  } else {
    // Safari
    // TODO : Support desktop Safari.
    target.removeEventListener('touchstart', listeners.onPointerDown);
    target.removeEventListener('touchend', listeners.onPointerUp);
    target.removeEventListener('touchmove', listeners.onPointerMove);
    target.removeEventListener('touchcancel', listeners.onPointerUp);

    target.removeEventListener('gesturestart', listeners.onGestureStart);
    target.removeEventListener('gesturechange', listeners.onGestureChange);
    target.removeEventListener('gestureend', listeners.onGestureEnd);
  }
};
